import { Button, Tabs } from '@eleo-rh/core-ui'
import Accreditation from 'containers/Catalog/Accreditation/Accreditation'
import Matrix from 'containers/Catalog/Matrix'
import Training from 'containers/Catalog/Training/Training'
import { useI18n } from 'context/I18nProvider'
import { useProfile } from 'context/ProfileProvider'
import { useTitle } from 'hooks/title'
import { useNavigate, useParams } from 'react-router-dom'

function CatalogNav() {
  const { lang, tab } = useParams()
  const navigate = useNavigate()
  const { hasPermission } = useProfile()
  const { i18n } = useI18n()
  useTitle(i18n('menu.catalog'))

  const TABS = [
    {
      key: 'training',
      label: i18n('label.training.search').toUpperCase(),
      children: <Training />,
      permission: 'CATALOG_CAN_SEE_CATALOG',
    },
    {
      key: 'accreditation',
      label: i18n('menu.admin_accreditations').toUpperCase(),
      children: <Accreditation />,
      permission: 'ACCREDITATION_CAN_SEE_CATALOG',
    },
    {
      key: 'matrix',
      children: <Matrix />,
      label: i18n('page_title.jobs_references').toUpperCase(),
      permission: 'MATRIX_CAN_SEE_MATRIX',
    },
  ]

  const tabs = TABS.filter(t => hasPermission(t.permission))

  const handleChange = (key: string) => navigate(`/${lang}/catalog/${key}`)

  const tabBarExtraContent = (
    tab === 'training' && hasPermission('CATALOG_CREATE_OUT_OF_CATALOG') && (
      <div className="flex items-center">
        <span className="text-sm mr-4">{i18n('question.you_dont_find_your_training')}</span>
        <Button onClick={() => navigate('free-wish')}>{i18n('action.free_wish')}</Button>
      </div>
    )
  )

  return (
    <Tabs
      activeKey={tab}
      items={tabs}
      onChange={handleChange}
      destroyOnHidden
      tabBarExtraContent={tabBarExtraContent}
    />
  )
}

export default CatalogNav
